export const GET_RESERVATIONS_BY_PARAM = 'GET_RESERVATIONS_BY_PARAM'
export const SET_RESERVATIONS_BY_PARAM = 'SET_RESERVATIONS_BY_PARAM'
export const GET_RESERVATIONS_BY_PARAM_ERROR = 'GET_RESERVATIONS_BY_PARAM_ERROR'
export const CLEAR_RESERVATIONS_BY_PARAM_ERROR_STATE = 'CLEAR_RESERVATIONS_BY_PARAM_ERROR_STATE'
export const CLEAR_RESERVATIONS_BY_PARAM_STATE = 'CLEAR_RESERVATIONS_BY_PARAM_STATE'
export const SET_GUEST_RESERVATION_CANCEL_AMEND_POLICY = 'SET_GUEST_RESERVATION_CANCEL_AMEND_POLICY'
export const SET_VEHICLE_UPDATED_STATE = 'SET_VEHICLE_UPDATED_STATE'
export const CLEAR_VEHICLE_UPDATED_STATE = 'CLEAR_VEHICLE_UPDATED_STATE'
export const UPDATE_VEHICLE_ERROR = 'UPDATE_VEHICLE_ERROR'
